import { defineComponent as _defineComponent } from 'vue'
import ActionModal from 'JS/components/modals/ActionModal.vue';
import BButton from 'JS/components/BButton.vue';
import { BButtonSubmitButton, BForm } from 'Src/js/components/blain-form';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmRemovalModal',
  props: {
    title: null,
    isGiftCard: { type: Boolean }
  },
  emits: ["continueRemoval", "cancel"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'continueRemoval'): void;
	(e: 'cancel'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	title?: string;
	isGiftCard?: boolean;
}





const loading = ref(false);
function onSubmit() {
	loading.value = true;
	emit('continueRemoval');
}


return { __sfc: true,props, emit, loading, onSubmit, ActionModal, BButton, BButtonSubmitButton, BForm }
}

})